import { GenericBackendResponse } from '../genericBackendResponse';
import { PensionPlanTransfer } from './interfaces/PensionPlanTransfer';

const getMyPensionPlanTransfers = async (
	token: string
): Promise<GenericBackendResponse<PensionPlanTransfer[]>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/pension-plan-transfers/my-transfers`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	const payload: GenericBackendResponse<PensionPlanTransfer[]> = await response.json();

	return payload;
};

export default getMyPensionPlanTransfers;
